import React from "react";

import SearchField from "app/components/SearchField";

export default ({ input, ...rest }) => {
  const { value, onChange } = input;

  return (
    <SearchField value={value} onChange={onChange} {...rest}></SearchField>
  );
};
